import { getNewApiBaseUrl } from "./newApiFallback";

export function resolveRewardImg(img, id) {
  if (typeof img === "string" && img.trim()) {
    if (
      img.startsWith("data:") ||
      img.startsWith("http://") ||
      img.startsWith("https://") ||
      img.startsWith("blob:")
    ) {
      return img;
    }
    const base = (getNewApiBaseUrl() || "").replace(/\/$/, "");
    return `${base}${img.startsWith("/") ? img : `/${img}`}`;
  }

  if (id) {
    const base = (getNewApiBaseUrl() || "").replace(/\/$/, "");
    return `${base}/api/koala/v1/reward/${id}/image`;
  }

  return "";
}
